function readingTime() {
	const article = document.getElementsByTagName("article")[0];
	const text = article.innerText;
	const words = text.trim().split(/\s+/).length;
	const time = Math.ceil(words / 250);
	const node = document.createElement("p");
	node.classList.add("text-muted");
	node.innerText = time + " min read";
	article.getElementsByTagName("header")[0].appendChild(node);
}

readingTime();
